export const barcodeImage = (text: string | number) => `/bc/?bcid=code128&text=${text}&includetext&height=6&scale=5`;
